import React, { useEffect, useState } from 'react';
import { createHtmlComponent, DomEvent } from './DialogUtils';
import { createPortal } from 'react-dom';

export interface LayerOptions {
  children?: React.ReactNode;
  actions?: DomEvent[];
  id: string;
  className: string;
  zIndex?: number;
  style?: React.CSSProperties;
  appendTo?: HTMLElement;
}

export const DEFAULT_OVERLAY_STYLE: React.CSSProperties = {
  position: 'fixed',
  width: '100%',
  height: '100%',
  left: '0',
  top: '0',
};

export function Overlay({
  children,
  className,
  zIndex,
  style,
  appendTo,
  actions,
  id,
}: LayerOptions): React.ReactPortal {
  const styleObject: React.CSSProperties = { ...DEFAULT_OVERLAY_STYLE, ...style };
  // TODO sasha: we don't need to provide zIndex as a separated parameter as it can be provided via "style" parameter
  styleObject.zIndex = zIndex;

  // Create new Component only when :appendTo, actions" changed
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [layer] = useState(() => createHtmlComponent({ zIndex, styleObject, className, appendTo, actions, id }));

  // useCallback(() => { // TODO Sasha what was this for?
  //   setElementStyle(layer, { className, style: styleObject });
  // }, [layer, className, styleObject]);

  useEffect(() => {
    return () => {
      if (!layer) return;
      if (!layer.parentElement) return;

      layer.parentElement.removeChild(layer);
    };
    // component unmount only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return createPortal(<>{children}</>, layer!);
}
